import React, { memo, FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import { Text } from 'mdlkit';
import { useIntl } from 'react-intl';
import { MemberId } from './InsuranceForm';
import DOBField from './PatientForm/DOBField';
import { MonikerCheck } from '../../interfaces/monikers';
import { required } from '../../utils/shared/validations';
import { validateDob } from '../../utils/register/validations';
import { StyledForm, FormSubmitLoadingButton } from '../shared/Styles';

const validateRecord = (values: MonikerCheck) => {
  return {
    ...validateDob(values),
  };
};

interface Props {
  onSubmit: (values: MonikerCheck) => Promise<void>;
  initialValues: MonikerCheck;
}

const MonikersForm: FunctionComponent<Props> = ({
  onSubmit,
  initialValues,
}: Props) => {
  const { formatMessage: f } = useIntl();

  return (
    <Form
      onSubmit={onSubmit}
      validate={validateRecord}
      initialValues={initialValues}
      render={({
        handleSubmit,
        submitting,
        values,
        pristine,
        submitFailed,
      }) => {
        if (pristine && submitFailed) {
          console.log('create error');
        }

        return (
          <StyledForm onSubmit={handleSubmit} spellCheck={false}>
            <Text>{f({ id: 'monikers.instructions' })}</Text>

            <Field
              name="affiliationId"
              type="hidden"
              component="input"
              validate={required}
            />

            <MemberId affiliationId={values.affiliationId} pt="none" />

            <DOBField />

            <FormSubmitLoadingButton
              id="monikerCheckBtn"
              type="submit"
              size="large"
              disabled={submitting}
              isLoading={submitting}
            >
              {f({ id: 'continueButton' })}
            </FormSubmitLoadingButton>
          </StyledForm>
        );
      }}
    />
  );
};

export default memo(MonikersForm);
